/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ============================================================================
 * Custom tabbed-collections section
 * Delegated click handler: any [data-action="bts-tabs-switch"] button
 * activates its target panel (data-tab-target -> matching panel id) and
 * deactivates sibling tabs/panels within the same section.
 * ============================================================================ */
(function () {
  function activateTab(button) {
    var targetId = button.getAttribute('data-tab-target');
    if (!targetId) return;
    var section = button.closest('.bts-tabs');
    if (!section) return;
    var panel = section.querySelector('#' + targetId);
    if (!panel) return;

    var tabs = section.querySelectorAll('[data-action="bts-tabs-switch"]');
    for (var i = 0; i < tabs.length; i++) {
      var t = tabs[i];
      var isActive = t === button;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    }

    var panels = section.querySelectorAll('.bts-tabs__panel');
    for (var j = 0; j < panels.length; j++) {
      var p = panels[j];
      if (p !== panel) {
        p.classList.remove('is-active');
        p.setAttribute('hidden', '');
      }
    }
    /* Reveal the target, then add is-active after a reflow so the
       opacity/translate transition runs as a fade-in. */
    panel.removeAttribute('hidden');
    panel.offsetHeight;
    panel.classList.add('is-active');
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-action="bts-tabs-switch"]');
    if (!btn) return;
    event.preventDefault();
    activateTab(btn);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var current = event.target.closest('[data-action="bts-tabs-switch"]');
    if (!current) return;
    var section = current.closest('.bts-tabs');
    if (!section) return;
    var tabs = Array.prototype.slice.call(
      section.querySelectorAll('[data-action="bts-tabs-switch"]')
    );
    var idx = tabs.indexOf(current);
    if (idx === -1) return;
    var nextIdx = event.key === 'ArrowRight'
      ? (idx + 1) % tabs.length
      : (idx - 1 + tabs.length) % tabs.length;
    var next = tabs[nextIdx];
    event.preventDefault();
    activateTab(next);
    next.focus();
  });
})();

/* ============================================================================
 * BTS PDP wishlist relocation
 * Wishlist by Square's WishlistAutoInjector auto-injects a wishlist button
 * INTO the buy-buttons area on product pages (its BUY_BUTTON_SELECTORS list
 * includes .product-form__add-button etc). Figma wants the wishlist on its
 * own row below the buy buttons (between two divider lines), not next to ATC.
 *
 * Solution: after the app injects, MOVE the injected element into our
 * .bts-pdp__wishlist container and hide our placeholder button.
 * ============================================================================ */
(function () {
  var SQUARE_SELECTORS = '.wishlist-auto-injected, .product-card-wishlist-btn, .wishlist-trigger.wishlist-initialized';

  function relocate() {
    var row = document.querySelector('.bts-pdp__wishlist');
    if (!row) return false;
    /* If Square already placed something inside our row, leave it. */
    if (row.querySelector(SQUARE_SELECTORS)) return true;
    /* Look for Square's injection anywhere outside our row. */
    var anywhere = document.querySelector(SQUARE_SELECTORS);
    if (!anywhere || row.contains(anywhere)) return false;
    /* Move the wishlist button to inside our row. */
    row.appendChild(anywhere);
    /* Hide our placeholder so we don't show two buttons. */
    var ph = row.querySelector('.bts-pdp__wishlist-btn:not(.product-card-wishlist-btn):not(.wishlist-trigger)');
    if (ph) ph.style.display = 'none';
    return true;
  }

  function init() {
    if (relocate()) return;
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function () {
        if (relocate()) obs.disconnect();
      });
      obs.observe(document.body, { childList: true, subtree: true });
      /* Safety: stop observing after 12s even if nothing happened. */
      setTimeout(function () { obs.disconnect(); }, 12000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================================
 * BTS PDP gallery prev/next arrows
 * Trigger the underlying Warehouse <media-gallery> next/previous slide via its
 * built-in `selectMedia` API (the gallery exposes a `selectNext` / `selectPrev`
 * method via dispatched events). We just find the next thumbnail in
 * .product-gallery__thumbnail-list and click it (Warehouse wires thumbnail
 * clicks to slide the main carousel).
 * ============================================================================ */
(function () {
  function step(dir) {
    var thumbs = document.querySelectorAll('.product-gallery__thumbnail');
    if (thumbs.length <= 1) return;
    var current = -1;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-nav-selected')) { current = i; break; }
    }
    if (current < 0) current = 0;
    var nextIdx = (current + dir + thumbs.length) % thumbs.length;
    thumbs[nextIdx].click();
  }

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-action="bts-gallery-prev"]');
    var next = e.target.closest('[data-action="bts-gallery-next"]');
    if (!prev && !next) return;
    e.preventDefault();
    step(prev ? -1 : 1);
  });
})();

/* ============================================================================
 * BTS carousel (generic)
 * One delegated handler drives every carousel marked with [data-bts-carousel].
 * Each carousel contains:
 *   - A track element with [data-bts-carousel-track] (scroll-snap horizontal)
 *   - Prev/next buttons with [data-action="bts-carousel-scroll"]
 *     and data-direction="prev|next"
 * One arrow click scrolls the track by one card width (first child width +
 * grid gap). Arrows auto-disable at the start/end. Used by "Often bought
 * together" (.bts-pdp__obt-carousel) and "Related Products" (.bts-related__carousel).
 * ============================================================================ */
(function () {
  function getTrack(carousel) {
    return carousel.querySelector('[data-bts-carousel-track]');
  }

  function step(track) {
    var first = track.firstElementChild;
    if (!first) return 0;
    var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '20', 10);
    return Math.round(first.getBoundingClientRect().width + gap);
  }

  function updateArrowState(carousel) {
    var track = getTrack(carousel);
    if (!track) return;
    var prev = carousel.querySelector('[data-direction="prev"]');
    var next = carousel.querySelector('[data-direction="next"]');
    var max = track.scrollWidth - track.clientWidth - 1;
    if (prev) prev.disabled = track.scrollLeft <= 0;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-action="bts-carousel-scroll"]');
    if (!btn) return;
    var carousel = btn.closest('[data-bts-carousel]');
    if (!carousel) return;
    var track = getTrack(carousel);
    if (!track) return;
    var dir = btn.getAttribute('data-direction') === 'next' ? 1 : -1;
    track.scrollBy({ left: step(track) * dir, behavior: 'smooth' });
  });

  /* Sync arrow disabled state with scroll position (capture so it fires for
     internal-track scrolls, not just window scrolls). */
  document.addEventListener('scroll', function (event) {
    var track = event.target.closest && event.target.closest('[data-bts-carousel-track]');
    if (!track) return;
    var carousel = track.closest('[data-bts-carousel]');
    if (carousel) updateArrowState(carousel);
  }, true);

  function initAll() {
    var carousels = document.querySelectorAll('[data-bts-carousel]');
    for (var i = 0; i < carousels.length; i++) updateArrowState(carousels[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('resize', initAll);

  /* The theme's product-recommendations JS replaces section innerHTML
     directly (no shopify:section:load fires). Watch for new carousels
     being inserted into the DOM and init them. */
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var a = 0; a < added.length; a++) {
          var node = added[a];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-bts-carousel]')) {
            updateArrowState(node);
          } else if (node.querySelectorAll) {
            var nested = node.querySelectorAll('[data-bts-carousel]');
            for (var n = 0; n < nested.length; n++) updateArrowState(nested[n]);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ============================================================================
 * Custom header mega menu
 * Desktop (hover-capable + fine pointer): CSS handles open via :hover.
 * Touch / coarse pointer: first tap on the trigger opens the panel and
 * suppresses navigation; second tap on the same trigger (now `.is-open`)
 * follows the link. Clicking outside any open panel closes it. Escape closes.
 * ============================================================================ */
(function () {
  var hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');

  function closeAll(except) {
    var items = document.querySelectorAll('.bts-header__nav-item.has-mega-menu.is-open');
    for (var i = 0; i < items.length; i++) {
      if (items[i] === except) continue;
      items[i].classList.remove('is-open');
      var link = items[i].querySelector('[data-action="bts-mega-toggle"]');
      if (link) link.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-action="bts-mega-toggle"]');

    if (trigger) {
      var item = trigger.closest('.bts-header__nav-item.has-mega-menu');
      if (!item) return;

      // Hover-capable devices: don't intercept clicks; let the link navigate.
      if (hoverMQ.matches) return;

      // Touch / coarse: first tap opens; if already open, allow nav.
      if (item.classList.contains('is-open')) return;
      event.preventDefault();
      closeAll(item);
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      return;
    }

    // Click outside any mega-menu trigger or panel: close all.
    if (!event.target.closest('.bts-header__nav-item.has-mega-menu')) {
      closeAll(null);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeAll(null);
  });
})();

/* ============================================================================
 * Custom mobile menu (expand-down accordion)
 * No vendor JS dependency. Three delegated behaviours:
 *   - bts-menu-open   : the header hamburger -- toggles the menu
 *   - bts-menu-close  : the dark overlay -- closes the menu
 *   - bts-menu-toggle : an accordion row -- expands/collapses its panel
 * Escape also closes the menu. On open, the header's bottom edge is measured
 * so the panel content clears the floating header card.
 * ============================================================================ */
(function () {
  var menu = document.getElementById('bts-mobile-menu');
  if (!menu) return;
  var panel = menu.querySelector('.bts-mobile-menu__panel');
  if (!panel) return;

  function getBurger() {
    return document.querySelector('[data-action="bts-menu-open"]');
  }

  /* Measure the header card: --cmm-header-bottom (where the dropdown starts)
     and --cmm-header-left (the gutter, reused for both left and right insets
     so the panel can never go asymmetric). */
  function setHeaderMetrics() {
    var header = document.querySelector('.bts-header');
    if (!header) return;
    var r = header.getBoundingClientRect();
    if (r.width <= 0) return;
    var root = document.documentElement;
    root.style.setProperty('--cmm-header-bottom', Math.round(r.bottom) + 'px');
    root.style.setProperty('--cmm-header-left', Math.round(r.left) + 'px');
  }

  /* Space from the panel's top edge to the bottom of the viewport. */
  function availableHeight() {
    var top = panel.getBoundingClientRect().top;
    return Math.max(0, window.innerHeight - top - 16);
  }

  /* Open: animate max-height 0 -> the REAL content height (capped to the
     viewport). Animating the true height -- instead of CSS's giant
     calc() -- means the motion is accurately paced, not a fast snap. */
  function openMenu() {
    setHeaderMetrics();
    panel.style.overflowY = 'hidden';
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bts-menu-open');
    var burger = getBurger();
    if (burger) burger.setAttribute('aria-expanded', 'true');

    /* Closed state is 25px (the bts.css "behind the header" overlap), NOT 0
       -- a 0 baseline exposes the header's corner area during the radius
       animation on close. Start from 25 so the open animation grows from
       fully-hidden-behind-header to full content. */
    panel.style.maxHeight = '25px';
    panel.offsetHeight; // commit the 25 before animating
    panel.style.maxHeight = Math.min(panel.scrollHeight, availableHeight()) + 'px';
  }

  /* Close: animate max-height from the panel's current visible height -> 0. */
  function closeMenu() {
    panel.style.overflowY = 'hidden';
    panel.style.maxHeight = panel.getBoundingClientRect().height + 'px';
    panel.offsetHeight; // commit the current height
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    /* The header's bottom border/radius un-flatten is transitioned in CSS,
       so it animates IN SYNC with this close -- no flash, no late pop. */
    document.documentElement.classList.remove('bts-menu-open');
    var burger = getBurger();
    if (burger) burger.setAttribute('aria-expanded', 'false');
    /* Shrink to 25px (NOT 0) so the panel still covers the header's
       full bottom corner zone (24px radius + 1px border row) while the
       smooth radius animation back to 24 completes. */
    panel.style.maxHeight = '25px';
  }

  /* When the OPEN animation finishes, release the inline cap so expanding an
     accordion can grow the panel freely, and re-enable scrolling in case the
     expanded content runs taller than the viewport. */
  panel.addEventListener('transitionend', function (event) {
    if (event.propertyName !== 'max-height') return;
    if (menu.classList.contains('is-open')) {
      panel.style.maxHeight = '';
      panel.style.overflowY = 'auto';
    }
  });

  document.addEventListener('click', function (event) {
    // Hamburger: toggle the menu.
    if (event.target.closest('[data-action="bts-menu-open"]')) {
      event.preventDefault();
      if (menu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
      return;
    }

    // Dark overlay: close the menu.
    if (event.target.closest('[data-action="bts-menu-close"]')) {
      event.preventDefault();
      closeMenu();
      return;
    }

    // Accordion row: expand/collapse its panel in place.
    var toggle = event.target.closest('[data-action="bts-menu-toggle"]');
    if (toggle && menu.contains(toggle)) {
      event.preventDefault();
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var subId = toggle.getAttribute('aria-controls');
      var sub = subId ? document.getElementById(subId) : null;
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (sub) sub.classList.toggle('is-open', !expanded);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  window.addEventListener('resize', function () {
    if (menu.classList.contains('is-open')) setHeaderMetrics();
  });
})();

/* ============================================================================
 * Shop by Category -- mobile "See More"
 * On mobile a limited set of cards shows; "See More" reveals the next batch
 * by dropping the `--extra` modifier. Desktop shows everything (CSS only
 * hides `--extra` inside the mobile media query, so this never runs there).
 * ============================================================================ */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-action="bts-category-more"]');
    if (!button) return;
    event.preventDefault();

    var section = button.closest('.bts-category-grid');
    var grid = section ? section.querySelector('.bts-category-grid__grid') : null;
    if (!grid) return;

    var batch = parseInt(grid.getAttribute('data-mobile-batch'), 10) || 4;
    var hidden = grid.querySelectorAll('.bts-category-grid__card--extra');

    for (var i = 0; i < batch && i < hidden.length; i++) {
      hidden[i].classList.remove('bts-category-grid__card--extra');
    }

    if (grid.querySelectorAll('.bts-category-grid__card--extra').length === 0) {
      button.classList.add('is-done');
    }
  });
})();

/* ============================================================================
 * Featured collection -- mobile prev/next carousel
 * The vendor featured-collection ships no arrow controls. On mobile its card
 * row is a snap-scroller (styled in bts.css); this injects two circular arrow
 * buttons that scroll it one card at a time, keeps them centred on the card
 * image, and dims an arrow when the scroller can't move further that way.
 * On desktop the section is a static grid and the arrows are hidden by CSS.
 * ============================================================================ */
(function () {
  var ARROWS = {
    prev: '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M10 13 5 8l5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function initCarousel(section) {
    var list = section.querySelector('.product-list');
    if (!list || !list.querySelector('.bts-card')) return;
    if (section.querySelector('.bts-fc-arrow')) return;

    section.style.position = 'relative';

    function step() {
      var card = list.querySelector('.bts-card');
      var styles = window.getComputedStyle(list);
      var gap = parseInt(styles.columnGap || styles.gap, 10) || 12;
      return card ? Math.round(card.getBoundingClientRect().width + gap) : 200;
    }

    function makeArrow(dir) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bts-fc-arrow bts-fc-arrow--' + dir;
      button.setAttribute('aria-label', dir === 'prev' ? 'Previous products' : 'Next products');
      button.innerHTML = ARROWS[dir];
      button.addEventListener('click', function () {
        list.scrollBy({ left: dir === 'prev' ? -step() : step(), behavior: 'smooth' });
      });
      return button;
    }

    var prev = makeArrow('prev');
    var next = makeArrow('next');
    section.appendChild(prev);
    section.appendChild(next);

    /* Centre the arrows vertically on the card image. */
    function positionArrows() {
      var media = list.querySelector('.bts-card__media');
      if (!media) return;
      var sectionTop = section.getBoundingClientRect().top;
      var box = media.getBoundingClientRect();
      var centerY = (box.top - sectionTop) + (box.height / 2);
      section.style.setProperty('--bts-fc-arrow-top', Math.round(centerY) + 'px');
    }

    /* Dim an arrow when the scroller is already at that end. */
    function updateArrows() {
      var maxScroll = list.scrollWidth - list.clientWidth;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= maxScroll - 1;
    }

    positionArrows();
    updateArrows();
    list.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', function () {
      positionArrows();
      updateArrows();
    });

    /* Re-centre when the FIRST card's image finishes loading. The initial
       positionArrows() runs synchronously, before any image has decoded,
       so the media box height it measured is the placeholder height (often
       smaller than the final image). Without this listener the arrows land
       near the top of the card -- visually off-centre. */
    var firstImg = list.querySelector('.bts-card__media img');
    if (firstImg) {
      if (firstImg.complete) {
        positionArrows();
      } else {
        firstImg.addEventListener('load', positionArrows, { once: true });
      }
    }

    /* And any subsequent layout shifts in the section (font swap, wishlist
       app injecting markup, etc.) -- ResizeObserver covers cases that scroll
       and resize events miss. */
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () { positionArrows(); });
      var media = list.querySelector('.bts-card__media');
      if (media) ro.observe(media);
    }
  }

  var sections = document.querySelectorAll('[data-section-type="featured-collection"]');
  for (var i = 0; i < sections.length; i++) {
    initCarousel(sections[i]);
  }
})();

/* ============================================================================
 * Shop by Brand -- mobile "See More"
 * On mobile a limited set of brand cards shows; "See More" reveals the next
 * batch by dropping the `--extra` modifier. Desktop shows the full scroll row
 * (CSS only hides `--extra` inside the mobile media query, so this is a no-op
 * there).
 * ============================================================================ */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-action="bts-brand-more"]');
    if (!button) return;
    event.preventDefault();

    var section = button.closest('.bts-brand-grid');
    var row = section ? section.querySelector('.bts-brand-grid__row') : null;
    if (!row) return;

    var batch = parseInt(row.getAttribute('data-mobile-batch'), 10) || 3;
    var hidden = row.querySelectorAll('.bts-brand-grid__card--extra');

    for (var i = 0; i < batch && i < hidden.length; i++) {
      hidden[i].classList.remove('bts-brand-grid__card--extra');
    }

    if (row.querySelectorAll('.bts-brand-grid__card--extra').length === 0) {
      button.classList.add('is-done');
    }
  });
})();

/* ============================================================================
 * Press Centre -- mobile carousel (prev/next arrows + progress bar)
 * Desktop is a static 3-card row; the arrows and progress bar are hidden by
 * CSS there. On mobile this injects the two circular arrow buttons, scrolls
 * the card row one card at a time, and keeps the progress bar in sync.
 * ============================================================================ */
(function () {
  var ARROWS = {
    prev: '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M10 13 5 8l5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function initPress(section) {
    var row = section.querySelector('.bts-press__row');
    if (!row || !row.querySelector('.bts-press__card')) return;
    if (section.querySelector('.bts-press-arrow')) return;

    section.style.position = 'relative';
    var bar = section.querySelector('.bts-press__progress-bar');

    function step() {
      var card = row.querySelector('.bts-press__card');
      var styles = window.getComputedStyle(row);
      var gap = parseInt(styles.columnGap || styles.gap, 10) || 16;
      return card ? Math.round(card.getBoundingClientRect().width + gap) : 280;
    }

    function makeArrow(dir) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bts-press-arrow bts-press-arrow--' + dir;
      button.setAttribute('aria-label', dir === 'prev' ? 'Previous articles' : 'Next articles');
      button.innerHTML = ARROWS[dir];
      button.addEventListener('click', function () {
        row.scrollBy({ left: dir === 'prev' ? -step() : step(), behavior: 'smooth' });
      });
      return button;
    }

    var prev = makeArrow('prev');
    var next = makeArrow('next');
    section.appendChild(prev);
    section.appendChild(next);

    function positionArrows() {
      var media = row.querySelector('.bts-press__media');
      if (!media) return;
      var sectionTop = section.getBoundingClientRect().top;
      var box = media.getBoundingClientRect();
      section.style.setProperty('--bts-press-arrow-top', Math.round((box.top - sectionTop) + (box.height / 2)) + 'px');
    }

    function update() {
      var maxScroll = row.scrollWidth - row.clientWidth;
      prev.disabled = row.scrollLeft <= 1;
      next.disabled = row.scrollLeft >= maxScroll - 1;
      if (bar && row.scrollWidth > 0) {
        bar.style.width = Math.min(100, (row.clientWidth / row.scrollWidth) * 100) + '%';
        bar.style.left = (row.scrollLeft / row.scrollWidth) * 100 + '%';
      }
    }

    positionArrows();
    update();
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () {
      positionArrows();
      update();
    });

    /* Same fix as featured-collection: the press card image is usually
       lazy-loaded, so the initial positionArrows() measured a small
       placeholder box and parked the arrows near the top. Re-run once
       the first image finishes loading, and again on any media-box
       resize via ResizeObserver. */
    var firstImg = row.querySelector('.bts-press__media img');
    if (firstImg) {
      if (firstImg.complete) {
        positionArrows();
      } else {
        firstImg.addEventListener('load', positionArrows, { once: true });
      }
    }

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () { positionArrows(); });
      var media = row.querySelector('.bts-press__media');
      if (media) ro.observe(media);
    }
  }

  var pressSections = document.querySelectorAll('[data-section-type="bts-press"]');
  for (var i = 0; i < pressSections.length; i++) {
    initPress(pressSections[i]);
  }
})();


/* ============================================================================
 * Compare control -- loading state, tooltip + keyboard support
 * The Comparable app wires our `.add-to-comparable` icon (Custom Controls) and
 * toggles an `in-comparison` class on it -- but the round-trip can take a
 * couple of seconds. This shows a spinner (`is-loading`) from the click until
 * the app confirms, keeps the tooltip/aria-label in sync, and lets keyboard
 * users activate it (the control is a <span role="button">).
 * ============================================================================ */
(function () {
  function syncTip(el) {
    var label = el.classList.contains('in-comparison')
      ? 'Remove from compare'
      : 'Add to compare';
    el.setAttribute('title', label);
    el.setAttribute('aria-label', label);
  }

  function init(el) {
    if (el.getAttribute('data-bts-compare') === '1') return;
    el.setAttribute('data-bts-compare', '1');
    syncTip(el);

    var pending = false;
    var pendingState = null;
    var timer = null;

    function stopLoading() {
      pending = false;
      el.classList.remove('is-loading');
      if (timer) { clearTimeout(timer); timer = null; }
      syncTip(el);
    }

    el.addEventListener('click', function () {
      if (pending) return;
      pending = true;
      pendingState = el.classList.contains('in-comparison');
      el.classList.add('is-loading');
      timer = setTimeout(stopLoading, 8000); // safety net -- never stay stuck
    });

    /* When the app flips `in-comparison`, the action has completed. */
    new MutationObserver(function () {
      if (pending) {
        if (el.classList.contains('in-comparison') !== pendingState) stopLoading();
      } else {
        syncTip(el);
      }
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  var els = document.querySelectorAll('.bts-card__compare.add-to-comparable');
  for (var i = 0; i < els.length; i++) {
    init(els[i]);
  }

  /* Enter / Space activate the compare control. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var el = event.target.closest('.bts-card__compare.add-to-comparable');
    if (!el) return;
    event.preventDefault();
    el.click();
  });
})();

/* ============================================================================
 * FAQ accordions (bts-faq + bts-faq-columns)
 * Each question is a button; clicking it toggles the item's `is-open` class
 * and animates the answer panel's max-height open/closed -- the same smooth
 * technique as the mobile menu. After an open it releases the cap to `none`
 * so the panel can reflow freely.
 * ============================================================================ */
(function () {
  function panelOf(item) {
    return item.querySelector('.bts-faq__a-wrap, .bts-faq2__a-wrap');
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.bts-faq__q, .bts-faq2__q');
    if (!btn) return;
    var item = btn.closest('.bts-faq__item, .bts-faq2__item');
    if (!item) return;

    var opening = !item.classList.contains('is-open');
    item.classList.toggle('is-open', opening);
    btn.setAttribute('aria-expanded', opening ? 'true' : 'false');

    var panel = panelOf(item);
    if (!panel) return;

    if (opening) {
      panel.style.maxHeight = '0px';
      panel.offsetHeight; // commit the 0 before animating
      panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.offsetHeight; // commit the current height before collapsing
      panel.style.maxHeight = '0px';
    }
  });

  /* When an open transition finishes, release the cap so the panel keeps its
     natural height (and adapts if the content/viewport changes). */
  document.addEventListener('transitionend', function (event) {
    if (event.propertyName !== 'max-height') return;
    var panel = event.target;
    if (!panel.classList) return;
    if (!panel.classList.contains('bts-faq__a-wrap') &&
        !panel.classList.contains('bts-faq2__a-wrap')) return;
    var item = panel.closest('.bts-faq__item, .bts-faq2__item');
    if (item && item.classList.contains('is-open')) {
      panel.style.maxHeight = 'none';
    }
  });
})();

/* ============================================================================
 * Header search overlay (slide-down search pill + dark backdrop).
 * Triggered by the search icon (data-bts-search-toggle); closed by the
 * close button, the backdrop, or Esc. Submits to the standard /search
 * page; empty submissions are blocked so the form does not navigate to
 * /search?q= with no query. Measures the header's bottom edge at open
 * time so the panel sits directly under the header on both desktop and
 * mobile (and adapts when the announcement bar is present).
 * ============================================================================ */
(function () {
  var overlay = document.querySelector('[data-bts-search-overlay]');
  if (!overlay) return;
  var input = overlay.querySelector('[data-bts-search-input]');
  var form = overlay.querySelector('[data-bts-search-form]');
  var toggle = document.querySelector('[data-bts-search-toggle]');

  function measureHeaderBottom() {
    var header = document.querySelector('.shopify-section--bts-header');
    if (!header) return 96;
    var rect = header.getBoundingClientRect();
    return Math.max(0, Math.round(rect.bottom));
  }

  function open() {
    overlay.style.setProperty('--bts-search-top', measureHeaderBottom() + 'px');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('bts-search-open');
    // Defer focus so the slide-in transition starts cleanly (focus instantly
    // scrolls the input into view, which fights the transform animation).
    setTimeout(function () {
      if (input) input.focus();
    }, 120);
  }

  function close() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('bts-search-open');
    if (input) input.value = '';
  }

  // On phones the Boost search app renders its OWN full-screen panel rather
  // than the inline dropdown it shows on desktop. If we open our overlay too,
  // it flashes up first and then sits behind Boost's panel. So on phones we
  // skip our overlay entirely and hand straight off to Boost: focusing Boost's
  // init input (which it has bound to our overlay input) is what opens its
  // full-screen panel. Returns true if Boost was handed control.
  function handoffToBoostMobile() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) {
      return false;
    }
    var boostInput = document.getElementById('boost-sd__search-widget-init-input-0');
    var boostPanel = document.querySelector('.boost-sd__search-bar-wrapper--mobile');
    if (!boostInput || !boostPanel) return false; // Boost not ready -> use ours
    // Make sure ours is not lingering, then trigger Boost's panel.
    if (overlay.classList.contains('is-open')) close();
    boostInput.focus();
    return true;
  }

  // Delegated clicks: trigger toggles open; any close hook closes.
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-bts-search-toggle]')) {
      event.preventDefault();
      if (overlay.classList.contains('is-open')) {
        close();
      } else if (!handoffToBoostMobile()) {
        open();
      }
      return;
    }
    if (event.target.closest('[data-bts-search-close]')) {
      event.preventDefault();
      close();
    }
  });

  // Esc closes.
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
      close();
    }
  });

  // Block empty submissions so the form does not navigate to /search?q=
  // with nothing. Non-empty values submit naturally to /search?q=...&type=product.
  if (form) {
    form.addEventListener('submit', function (event) {
      var val = (input && input.value || '').trim();
      if (!val) {
        event.preventDefault();
        if (input) input.focus();
      }
    });
  }

  // Re-measure header bottom if the viewport resizes while the overlay
  // is open (e.g. orientation change, soft keyboard, dynamic header
  // height). Throttled with rAF.
  var resizeFrame = 0;
  window.addEventListener('resize', function () {
    if (!overlay.classList.contains('is-open')) return;
    if (resizeFrame) return;
    resizeFrame = requestAnimationFrame(function () {
      overlay.style.setProperty('--bts-search-top', measureHeaderBottom() + 'px');
      resizeFrame = 0;
    });
  });

  /* --------------------------------------------------------------------------
   * Boost search app -- mobile panel sync.
   *
   * The Boost vendor widget binds itself to OUR overlay input (it tags it
   * `boost-sd__search-widget-init-input`). On DESKTOP it renders results in an
   * inline dropdown inside our overlay -- no conflict, nothing to do. On MOBILE
   * it instead opens its OWN full-screen panel (`.boost-sd__search-bar-wrapper
   * --mobile`, position:fixed, z-index 99999999) ON TOP of our overlay. When
   * the user closes that panel, Boost just hides it (adds `boost-sd__g-hide`)
   * and leaves OUR overlay (z-index 80) sitting open underneath -- so the user
   * sees our search still up after dismissing Boost's.
   *
   * Fix: watch Boost's mobile panel and, whenever it goes from shown -> hidden
   * (Close button, backdrop, or Esc -- all add `boost-sd__g-hide`), close ours
   * too. The `--mobile` class only exists on phones, so this never touches the
   * desktop flow. Boost builds the panel lazily on first search, so we scan for
   * it on every DOM change (cheap querySelector, guarded by a WeakSet).
   * -------------------------------------------------------------------------- */
  var boostWatched = new WeakSet();
  function boostPanelHidden(el) {
    return el.classList.contains('boost-sd__g-hide') ||
           getComputedStyle(el).display === 'none';
  }
  function watchBoostPanel(el) {
    if (boostWatched.has(el)) return;
    boostWatched.add(el);
    var wasVisible = !boostPanelHidden(el);
    new MutationObserver(function () {
      var hidden = boostPanelHidden(el);
      if (wasVisible && hidden && overlay.classList.contains('is-open')) {
        close();
      }
      wasVisible = !hidden;
    }).observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
  }
  function scanBoostPanels() {
    var panels = document.querySelectorAll('.boost-sd__search-bar-wrapper--mobile');
    for (var i = 0; i < panels.length; i++) watchBoostPanel(panels[i]);
  }
  scanBoostPanels();
  new MutationObserver(scanBoostPanels).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* ============================================================================
 * Compare page (/pages/compare) -- Comparable app
 *
 * Two enhancements over what the app gives us:
 * 1) Trash-icon "remove from comparison" button on every product card -- the
 *    app ships this only when a "current product" context is set; the user
 *    wants it on every card. We inject a brand-styled trash button into
 *    each `.add-to-cart-wrap` that rewrites the URL's `products` list and
 *    reloads, which is exactly what the app's own remove flow does.
 * 2) A custom thin brand-red horizontal scrollbar (Figma 1:633) since the
 *    user explicitly wants a non-native scroll indicator. The native scroll
 *    is hidden via CSS; we render a sticky bar that mirrors the
 *    `.comparable-container` scrollLeft / scrollWidth and is draggable.
 *
 * Pattern-based -- no hard-coded row/product counts, runs on whatever the
 * app renders.
 * ============================================================================ */
(function () {
  // The `comparison-page` body class is added by the Comparable app at
  // runtime (not by Liquid), so checking it at script-load can fail.
  // Use the URL path as the trigger -- the page is always at
  // `/pages/compare`. We still poll for the app's table since it's JS-
  // injected after the page DOM is ready.
  if (window.location.pathname.indexOf('/pages/compare') === -1) return;

  function whenReady(cb) {
    if (document.querySelector('.comparable-container .comparison-table')) {
      cb();
      return;
    }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (document.querySelector('.comparable-container .comparison-table') || tries > 60) {
        clearInterval(iv);
        cb();
      }
    }, 150);
  }

  /* --- Trash-icon injection -- DISABLED (user feedback 2026-05-20).
     User asked to keep the Comparable app's OWN native `.remove-from-
     compare` button (when the app renders it) and not add a custom one,
     so this function is a no-op. Kept as a stub so the MutationObserver
     wire-up below still works if we want to re-enable later. */
  function injectRemoveButtons() {
    /* no-op */
  }

  /* --- Move the app's native delete next to Add to Cart (client 2026-06-04).
     The wishlist heart and the per-product remove (`.remove-from-compare`)
     both landed at the same image corner, so the heart was hidden. Instead of
     hiding the wishlist, we relocate the delete to sit to the RIGHT of each
     Add to Cart button (`.add-to-cart-wrap`) and let the wishlist heart show
     at the image corner like on the loop-item cards. Idempotent +
     pattern-based (pairs the i-th remove with the i-th add-to-cart wrap, which
     share the app's left-to-right product order). */
  function relocateRemoveToCart() {
    var wraps = document.querySelectorAll('.comparable-container .add-to-cart-wrap');
    if (!wraps.length) return;
    var removes = document.querySelectorAll('.comparable-container .remove-from-compare');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      if (wrap.querySelector(':scope > .remove-from-compare')) continue; // already moved
      var rm = removes[i] || null;
      if (rm && rm.parentNode !== wrap) {
        wrap.classList.add('bts-cmp-cart-row');
        wrap.appendChild(rm);
      }
    }
  }

  /* --- Custom horizontal scrollbar --- */
  function setupCustomScrollbar() {
    var container = document.querySelector('.comparable-container');
    if (!container) return;
    if (container.parentNode.querySelector('.bts-compare-scrollbar')) return;

    var bar = document.createElement('div');
    bar.className = 'bts-compare-scrollbar';
    bar.setAttribute('role', 'scrollbar');
    bar.setAttribute('aria-controls', container.id || 'comparable-container');
    var thumb = document.createElement('div');
    thumb.className = 'bts-compare-scrollbar__thumb';
    bar.appendChild(thumb);

    // Insert directly after the container so it sits at the bottom of
    // the scrollable area visually.
    container.parentNode.insertBefore(bar, container.nextSibling);

    function update() {
      var clientW = container.clientWidth;
      var scrollW = container.scrollWidth;
      var maxScroll = scrollW - clientW;
      var hasScroll = maxScroll > 2;
      bar.classList.toggle('is-active', hasScroll);
      if (!hasScroll) return;

      var ratio = clientW / scrollW;
      var trackW = bar.clientWidth;
      var thumbW = Math.max(40, Math.round(trackW * ratio));
      thumb.style.width = thumbW + 'px';

      var pos = container.scrollLeft / maxScroll;       // 0..1
      var thumbMax = trackW - thumbW;
      thumb.style.transform = 'translateX(' + Math.round(pos * thumbMax) + 'px)';
    }

    container.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    /* --- Desktop mouse-drag on the thumb -------------------------------------
       Grab the thumb and drag to scroll the table 1:1 (smooth -- we set
       scrollLeft directly on each move, the container's scroll event then
       repaints the thumb). Touch is left to the native table swipe, so we
       ignore non-mouse pointers (matches the earlier "no touch-drag" ask).
       Pointer capture keeps the drag alive even when the cursor leaves the
       thin thumb. */
    var dragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = false;

    thumb.addEventListener('pointerdown', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return; // touch -> native scroll
      dragging = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragStartScroll = container.scrollLeft;
      bar.classList.add('is-dragging');
      try { thumb.setPointerCapture(e.pointerId); } catch (_) {}
      e.preventDefault();
    });

    thumb.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var trackW = bar.clientWidth;
      var thumbMax = trackW - thumb.offsetWidth;
      if (thumbMax <= 0) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 2) dragMoved = true;
      var maxScroll = container.scrollWidth - container.clientWidth;
      container.scrollLeft = dragStartScroll + (dx / thumbMax) * maxScroll;
      e.preventDefault();
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      bar.classList.remove('is-dragging');
      try { thumb.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);

    /* Click-to-jump on the TRACK: clicking the track (not the thumb) moves the
       scroll so the clicked point becomes the centre of the thumb. Skipped when
       the click is really the tail of a drag, or lands on the thumb itself. */
    bar.addEventListener('click', function (e) {
      if (e.target === thumb || dragMoved) { dragMoved = false; return; }
      var trackRect = bar.getBoundingClientRect();
      var thumbW = thumb.offsetWidth;
      var x = e.clientX - trackRect.left - (thumbW / 2);
      var maxX = trackRect.width - thumbW;
      x = Math.max(0, Math.min(maxX, x));
      var ratio = maxX > 0 ? x / maxX : 0;
      container.scrollLeft = ratio * (container.scrollWidth - container.clientWidth);
    });

    update();
  }

  whenReady(function () {
    injectRemoveButtons();
    relocateRemoveToCart();
    setupCustomScrollbar();
    // Re-run if the app re-renders the table (e.g. after "show only
    // differences" toggle).
    var obs = new MutationObserver(function () { injectRemoveButtons(); relocateRemoveToCart(); });
    var t = document.querySelector('.comparison-table');
    if (t) obs.observe(t, { childList: true, subtree: true });
  });
})();

/* ============================================================================
 * Filter sidebar (snippets/bts-collection-filters.liquid)
 * Three delegated behaviours, all event-delegated off document so they keep
 * working after Warehouse's filter-AJAX swaps the form's DOM.
 *
 *  1. Categories tree expand/collapse  (data-action="bts-filter-tree-toggle")
 *  2. Dual-thumb price slider          (.bts-filter-price__range pair)
 *  3. Soft-AJAX category leaf clicks   ([data-bts-filter-collection-link])
 *
 * Warehouse's own filter JS handles the URL-state + grid swap on every input
 * change inside #desktop-filters-form, so we don't re-implement that here.
 * ============================================================================ */
(function () {
  /* ----- 1. Tree expand/collapse ------------------------------------------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-action="bts-filter-tree-toggle"]');
    if (!btn) return;
    var parent = btn.closest('.bts-filter-tree__item');
    if (!parent) return;
    var isOpen = parent.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  /* ----- 1b. Card "Clear" buttons (price / brand / status) ----------------
     Each non-category filter card has a Clear button
     (data-action="bts-filter-clear"). Reset that card's own inputs, then
     dispatch a single `change` so Warehouse's filter AJAX rebuilds the grid
     and URL WITHOUT those params -- the exact path every other filter input
     already uses, so price/brand/status all drop out cleanly.

     The Categories card's Clear is a plain <a> to the bare collection URL, so
     it needs no JS -- it already resets to the current collection page. */
  document.addEventListener('click', function (event) {
    var clearBtn = event.target.closest('[data-action="bts-filter-clear"]');
    if (!clearBtn) return;
    event.preventDefault();

    var card = clearBtn.closest('[data-bts-filter-card]');
    if (!card) return;

    var touched = false;
    var lastInput = null;

    // Brand + status are checkboxes -- uncheck any that are ticked.
    var boxes = card.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < boxes.length; i++) {
      lastInput = boxes[i];
      if (boxes[i].checked) { boxes[i].checked = false; touched = true; }
    }

    // Price -- blank the number inputs (only carry a value when a price is
    // actually applied) and snap the sliders + track back to full range.
    var track = card.querySelector('.bts-filter-price__track');
    if (track) {
      var nums = card.querySelectorAll('.bts-filter-price__input');
      for (var j = 0; j < nums.length; j++) {
        lastInput = nums[j];
        if (nums[j].value !== '') { nums[j].value = ''; touched = true; }
      }
      var ranges = track.querySelectorAll('.bts-filter-price__range');
      if (ranges[0]) { ranges[0].value = ranges[0].min; }
      if (ranges[1]) { ranges[1].value = ranges[1].max; }
      track.style.setProperty('--p-lo', '0%');
      track.style.setProperty('--p-hi', '100%');
    }

    // Nothing was active -> no reload needed.
    if (!touched || !lastInput) return;

    // Warehouse's filter AJAX listens for `change` on form inputs and reads
    // the WHOLE form via FormData, so one dispatch clears the group.
    lastInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----- 2. Dual-thumb price slider ---------------------------------------
     Update the visible track fill (--p-lo / --p-hi on the .bts-filter-price__track)
     whenever either thumb moves. Also keep the linked number inputs (which are
     the real `name="filter.v.price.gte/lte"` form fields) in sync so the
     existing AJAX form submission picks up the new values.
     We delegate from the document so this works after AJAX re-renders too. */
  function syncPriceSlider(track) {
    var ranges = track.querySelectorAll('.bts-filter-price__range');
    if (ranges.length < 2) return;
    var lo = +ranges[0].value;
    var hi = +ranges[1].value;
    var min = +ranges[0].min;
    var max = +ranges[0].max;
    if (lo > hi) {
      var swap = lo; lo = hi; hi = swap;
      ranges[0].value = lo;
      ranges[1].value = hi;
    }
    var range = Math.max(1, max - min);
    var loPct = ((lo - min) / range) * 100;
    var hiPct = ((hi - min) / range) * 100;
    track.style.setProperty('--p-lo', loPct + '%');
    track.style.setProperty('--p-hi', hiPct + '%');

    // Sync the number inputs (these are the real form fields).
    var card = track.closest('[data-bts-filter-card="price"]');
    if (!card) return;
    var inputs = card.querySelectorAll('.bts-filter-price__input');
    if (inputs[0]) inputs[0].value = lo;
    if (inputs[1]) inputs[1].value = hi;
  }

  function dispatchPriceChange(track) {
    // When the user releases the thumb, dispatch a single change on one of the
    // number inputs so Warehouse's filter AJAX picks it up. Only ONE event is
    // needed -- the vendor reads ALL form data via FormData(form). Dispatching
    // on both inputs caused a double-reload (first fetch aborted, AbortError).
    var card = track.closest('[data-bts-filter-card="price"]');
    if (!card) return;
    var input = card.querySelector('.bts-filter-price__input');
    if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('input', function (event) {
    var range = event.target.closest('.bts-filter-price__range');
    if (!range) return;
    var track = range.closest('.bts-filter-price__track');
    if (!track) return;
    syncPriceSlider(track);
  });

  document.addEventListener('change', function (event) {
    var range = event.target.closest('.bts-filter-price__range');
    if (!range) return;
    var track = range.closest('.bts-filter-price__track');
    if (track) dispatchPriceChange(track);
  });

  /* ----- 3. Soft-AJAX category leaf clicks --------------------------------
     The category tree uses real <a href="/collections/{handle}"> links so
     SEO + back-button work. We intercept the click and fetch only the
     section containing the product grid (sections/main-collection.liquid),
     swap it in place, history.pushState. No full page reload. */
  function findGridSection() {
    // The product grid lives inside main-collection.liquid (used by BOTH
    // /collections/* and /search). Target by data-section-type, NOT
    // [data-section-id] alone -- header / footer / popups all carry
    // data-section-id too, and document.querySelector picks the FIRST
    // (the header section), which would leave the grid unchanged and
    // swap the header. That's the bug filter clicks were hitting.
    return document.querySelector('[data-section-type="collection"]');
  }

  function showCategoryLoadingState(loading) {
    var section = findGridSection();
    if (!section) return;
    section.classList.toggle('is-bts-filter-loading', !!loading);
  }

  /* Scroll after filter apply / category switch.
     Desktop (>= 1000px): scroll to very top of the page so the user
       sees the full header + title bar + toolbar.
     Mobile  (<  1000px): scroll to <main id="main"> so the user skips
       past the header straight to the product toolbar / spinner.
     Always uses smooth behavior so the jump never feels jarring -- pairs
     with `html { scroll-behavior: smooth }` in bts.css as a fallback. */
  function scrollToMain() {
    var isMobile = window.matchMedia('(max-width: 999px)').matches;
    if (!isMobile) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    var main = document.getElementById('main');
    if (!main) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    var styles = window.getComputedStyle(document.documentElement);
    var headerH = parseInt(styles.getPropertyValue('--header-height') || '0', 10);
    var isSticky = parseInt(styles.getPropertyValue('--header-is-sticky') || '0', 10);
    if (!headerH) {
      var hdr = document.querySelector('.header');
      headerH = hdr ? hdr.getBoundingClientRect().height : 0;
    }
    var offset = isSticky ? headerH + 8 : 8;
    var top = main.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  /* Re-bind Warehouse section JS after a soft-AJAX DOM swap.
     When we replace the collection section in place, the vendor's section
     instance is still bound to the OLD (detached) DOM nodes, so filter
     <input>s on the new DOM have no `change` listeners -- click a brand
     and nothing happens. Fix: dispatch the same `shopify:section:unload` /
     `shopify:section:load` events the theme editor fires; the Warehouse
     sections registry tears down the old instance and creates a fresh one
     bound to the new DOM. */
  function rebindSectionAfterSwap(oldSectionEl, newSectionEl, wrapperEl) {
    if (!oldSectionEl || !newSectionEl || !wrapperEl) return;
    var oldId = oldSectionEl.getAttribute('data-section-id');
    var newId = newSectionEl.getAttribute('data-section-id') || oldId;
    if (oldId) {
      document.dispatchEvent(new CustomEvent('shopify:section:unload', {
        bubbles: true,
        detail: { sectionId: oldId }
      }));
    }
    // Vendor handler reads `event.target.querySelector("[data-section-id]")`,
    // so dispatch on the wrapper (which now contains the new section).
    wrapperEl.dispatchEvent(new CustomEvent('shopify:section:load', {
      bubbles: true,
      detail: { sectionId: newId }
    }));
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-bts-filter-collection-link]');
    if (!link) return;
    // Modifier keys → let the browser handle (new tab, etc.).
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.button !== 0) return;

    var rawUrl = link.getAttribute('href');
    if (!rawUrl) return;

    event.preventDefault();

    /* If the click came from INSIDE the open mobile filter drawer, close it and
       release the scroll lock first. The drawer lives inside the collection
       section that the soft-AJAX swap below replaces, so the vendor Drawer
       instance never receives a close event -- leaving `html.is-locked`
       (overflow-y:hidden) stuck on <html> and freezing the page (no scroll).
       Other facets go through the vendor flow which manages the lock; only the
       category leaves bypass it. Fire the vendor close event (keeps aria/state
       in sync) AND defensively drop the lock class in case the vendor instance
       is already detached. Scoped to "drawer actually open" so desktop sidebar
       clicks -- and any unrelated open modal/mini-cart -- are never touched. */
    var btsFilterDrawer = document.getElementById('mobile-collection-filters');
    if (btsFilterDrawer && btsFilterDrawer.getAttribute('aria-hidden') === 'false') {
      document.dispatchEvent(new CustomEvent('collection-filter:close'));
      document.documentElement.classList.remove('is-locked');
    }

    showCategoryLoadingState(true);

    /* Carry current filter / sort params to the new collection URL so
       switching categories keeps any brand, price, availability, or sort
       the user already picked.  We skip `page` (always start at page 1)
       and `q` / `type` (irrelevant when navigating between collections). */
    var dest = new URL(rawUrl, window.location.origin);
    var cur  = new URLSearchParams(window.location.search);
    cur.forEach(function (val, key) {
      if (key.startsWith('filter.') || key === 'sort_by') {
        dest.searchParams.append(key, val);
      }
    });
    var url = dest.pathname + dest.search;

    // Fetch the destination collection page and pluck out the SAME section
    // type we have here -- target by data-section-type to avoid grabbing
    // the header section in the fetched doc.
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var currentSection = findGridSection();
        var newSection = doc.querySelector('[data-section-type="collection"]');
        if (currentSection && newSection) {
          var wrapper = currentSection.parentElement;
          currentSection.replaceWith(newSection);
          // Vendor JS was bound to the detached `currentSection`; without
          // re-init the brand / price / availability filters silently
          // become no-ops after the first category click.
          rebindSectionAfterSwap(currentSection, newSection, wrapper);
        } else {
          // If the destination page doesn't have a collection section, hard
          // navigate so the user still gets where they were going.
          window.location.href = url;
          return;
        }
        history.pushState({ btsFilter: true }, '', url);
        scrollToMain();
      })
      .catch(function () {
        // Fallback: hard navigate so the user still gets where they were going.
        window.location.href = url;
      })
      .finally(function () {
        showCategoryLoadingState(false);
      });
  });

  // Back/forward navigation: reload the section in place.
  window.addEventListener('popstate', function (event) {
    if (!event.state || !event.state.btsFilter) return;
    fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var currentSection = findGridSection();
        var newSection = doc.querySelector('[data-section-type="collection"]');
        if (currentSection && newSection) {
          var wrapper = currentSection.parentElement;
          currentSection.replaceWith(newSection);
          rebindSectionAfterSwap(currentSection, newSection, wrapper);
        }
      });
  });

  /* ----- Init: ensure track fill matches initial slider values on load --- */
  function initAllPriceTracks() {
    document.querySelectorAll('.bts-filter-price__track').forEach(syncPriceSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPriceTracks);
  } else {
    initAllPriceTracks();
  }

  /* ----- 4. Native sort <select> ------------------------------------------
     The Sort pill is a native <select data-bts-sort-select>. On change,
     rebuild the URL with the new sort_by param (keeping search q, filters,
     and other query params intact) and navigate. No need for vendor's
     value-picker JS -- the OS-level option list handles open/close. */
  document.addEventListener('change', function (event) {
    var sel = event.target.closest('[data-bts-sort-select]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    // Reset paging so we land on page 1 of the new sort.
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ----- 5. Filter loading spinner + scroll-to-top -------------------------
     Warehouse dispatches `theme:loading:start` / `theme:loading:end` for ANY
     AJAX action -- add-to-cart, wishlist toggle, quick-view, etc. -- not just
     filter changes. We only want to show the spinner + scroll when a FILTER
     actually changed, so we set an intent flag on the filter `change` event
     and only react to the loading events while the flag is set.

     Sort dropdown also counts -- it hard-navigates so it never reaches the
     loading handlers, but the flag is harmless. */
  var btsFilterIntent = false;

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.name) return;
    // Catch any filter.* input in the sidebar OR the price slider's hidden
    // submission, but skip add-to-cart quantity selects, variant pickers, etc.
    if (input.name.indexOf('filter.') === 0 || input.closest('[data-bts-filter-form]')) {
      btsFilterIntent = true;
    }
  }, true);

  document.addEventListener('theme:loading:start', function () {
    if (!btsFilterIntent) return;
    var section = findGridSection();
    if (section) {
      section.classList.add('is-bts-filter-loading');
      scrollToMain();
    }
  });
  document.addEventListener('theme:loading:end', function () {
    if (!btsFilterIntent) return;
    btsFilterIntent = false;
    var section = findGridSection();
    if (section) section.classList.remove('is-bts-filter-loading');
  });
})();

/* ============================================================================
 * Cart page -- take over the line-item +/- buttons.
 *
 * Vendor's Cart class POSTs to `/cart/change.js` with NO `.catch()`, so a
 * silently failed fetch (expired session, network blip, etc.) leaves the
 * click dead and the user sees nothing happen. We replace that flow with
 * one that gives instant feedback and degrades gracefully:
 *
 *   1. Listen in CAPTURE phase so we run before the vendor's bubble-phase
 *      delegated handler, then stopImmediatePropagation so the vendor never
 *      fires -- no double POST, no race.
 *   2. Immediately update the visible quantity input and disable both
 *      buttons in the row so the user gets feedback within one frame.
 *   3. Fire our own POST to /cart/change.js with proper success / error /
 *      network-failure branches. On success: reload the cart so prices,
 *      totals, and the recap update. On any failure: navigate via the
 *      server-rendered `data-href` so the cart change happens via the
 *      no-JS form path -- guaranteed to work even when the AJAX endpoint
 *      is gated.
 *
 * Scoped to `.template-cart`. Mini-cart drawer on other pages keeps the
 * vendor handler untouched.
 * ========================================================================== */
(function () {
  function isCartPage() {
    return document.body && document.body.classList.contains('template-cart');
  }

  if (!isCartPage()) return;

  function findRowInput(btn) {
    var row = btn.closest('tr') || btn.closest('.line-item') || btn.parentElement;
    if (!row) return null;
    // Match the input by the same data-line so the right quantity field
    // updates even when the row contains multiple selectors (phone + tablet
    // variants render both, with `hidden-phone` / `hidden-tablet-and-up`).
    var line = btn.getAttribute('data-line');
    return row.querySelector(
      '.quantity-selector__value[data-line="' + line + '"]'
    ) || row.querySelector('.quantity-selector__value');
  }

  function setRowBusy(btn, busy) {
    var row = btn.closest('tr') || btn.closest('.line-item');
    if (!row) return;
    row.classList.toggle('is-bts-qty-updating', !!busy);
    // Disable both qty buttons on the row while the change is in flight so
    // rapid double-clicks don't fire two POSTs (the second would race).
    var siblings = row.querySelectorAll(
      '[data-action="decrease-quantity"], [data-action="increase-quantity"]'
    );
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].disabled = !!busy;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      // STRICT whitelist -- our fast path only fires on the vendor's
      // dedicated `[-] N [+]` pill buttons inside an actual cart line-item
      // row. We deliberately require ALL of the following so we cannot
      // accidentally intercept anything an app might add:
      //   * BUTTON element with `.quantity-selector__button`
      //   * Sitting inside a `.quantity-selector` wrapper (the pill)
      //   * Sitting inside a `tr.line-item` (the cart line-item row)
      //   * NOT inside a Wishlist Suite Save-for-Later row / button
      //   * `data-action` is exactly decrease-/increase-quantity
      // Any miss => return early, no preventDefault, vendor + app handlers
      // continue to fire untouched. This is what lets "Save for later"
      // call its own save-then-remove sequence without our code stealing
      // the click.
      var btn = event.target.closest('button.quantity-selector__button');
      if (!btn) return;
      if (!btn.closest('.quantity-selector')) return;
      if (!btn.closest('tr.line-item')) return;
      if (btn.closest('.save-for-later-row')) return;
      if (btn.closest('.cart-save-for-later-btn')) return;
      var action = btn.getAttribute('data-action');
      if (action !== 'decrease-quantity' && action !== 'increase-quantity') return;

      var href = btn.getAttribute('data-href');
      var line = btn.getAttribute('data-line');
      var qtyAttr = btn.getAttribute('data-quantity');
      if (line == null || qtyAttr == null) return;
      var newQty = parseInt(qtyAttr, 10);
      if (isNaN(newQty)) return;

      // Block the vendor's delegated handler from firing too.
      event.preventDefault();
      event.stopImmediatePropagation();

      // INSTANT FEEDBACK -- update the visible input and lock the row before
      // the network round-trip begins. The full re-render happens on reload.
      var input = findRowInput(btn);
      if (input) input.value = newQty;
      setRowBusy(btn, true);

      function fallbackNavigate() {
        if (href) {
          window.location.href = href;
        } else {
          window.location.reload();
        }
      }

      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
        .then(function (response) {
          if (response.ok) {
            window.location.reload();
          } else {
            // 4xx / 5xx -- fall back to the server-rendered no-JS path so the
            // change still happens via the redirect flow.
            fallbackNavigate();
          }
        })
        .catch(function () {
          // Network error, blocked request, cookie expiry -- same fallback.
          fallbackNavigate();
        });
    },
    true // capture phase: run BEFORE vendor's delegated bubble handler.
  );
})();

/* ============================================================================
 * Re-init external apps after AJAX section content injection.
 *
 * The Recently-viewed-products section ships empty and fetches its product
 * cards via XHR after page load (RecentlyViewedProductsSection in theme.js).
 * Wishlist Suite (`wishlist-inject-button.js`) and the Comparable app
 * (`collection.js`) both bind to `.product-card-wishlist-btn` /
 * `.add-to-comparable` once on DOMContentLoaded, so AJAX-injected cards
 * never get a wishlist heart or a working compare button.
 *
 * Fix: when the placeholder gains children, dispatch a
 * `shopify:section:load` event on the section root. That is the standard
 * Shopify theme-editor event that well-behaved apps re-scan on. Wishlist
 * Suite also re-scans on a generic DOM mutation, but the explicit event is
 * what the Comparable app listens for.
 *
 * No-op on pages that do not have the recently-viewed section.
 * ========================================================================== */
(function () {
  if (typeof MutationObserver !== 'function') return;

  function wireRecentlyViewed(section) {
    var placeholder = section.querySelector('.recently-viewed-products-placeholder');
    if (!placeholder) return;
    var sectionId = section.getAttribute('data-section-id');
    var fired = false;

    var observer = new MutationObserver(function (mutations) {
      var added = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
          added = true;
          break;
        }
      }
      if (!added || fired) return;
      // The placeholder gained content -- the cards are now in the DOM.
      // Dispatch the editor-style event so external apps re-scan and bind
      // their wishlist / compare handlers to the freshly injected cards.
      fired = true;
      section.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: sectionId }
      }));
      // Some apps listen on document for a generic refresh event; fire that
      // too -- harmless on apps that ignore it.
      document.dispatchEvent(new CustomEvent('bts:cards:refreshed', {
        bubbles: true,
        detail: { container: placeholder }
      }));
      observer.disconnect();
    });

    observer.observe(placeholder, { childList: true, subtree: false });
  }

  function init() {
    var sections = document.querySelectorAll(
      '[data-section-type="recently-viewed-products"]'
    );
    for (var i = 0; i < sections.length; i++) {
      wireRecentlyViewed(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================================
 * Mobile: bypass the mini-cart drawer entirely.
 *
 * The drawer is a desktop-only convenience on this build. On mobile we
 * want:
 *   * Tapping the cart icon  -> navigate to /cart (full page)
 *   * Tapping Add to cart    -> server adds the item, cart count bumps
 *                               in the header, loading bar completes,
 *                               vendor's small "Product added" toast
 *                               flashes, but NO drawer slides in
 *
 * Vendor's `<buy-button>` handler and `Cart._onProductAdded` both branch
 * on `window.theme.cartType`. Switching it from "drawer" to "message"
 * before the first interaction is enough:
 *   * `addToCart_fn`            -> shows the success toast (good)
 *   * `_onProductAdded`         -> skips `_openMiniCart` (good)
 *   * `_onCartRefresh`          -> still runs (count + loading:end fire)
 *
 * We also strip `data-action="toggle-mini-cart"` off the cart anchor so
 * tapping the cart icon falls through to the anchor's native `href` and
 * lands on /cart, no flash of an empty drawer.
 *
 * Re-check on resize -> someone rotating from portrait to a tablet
 * landscape that crosses 641px should get the full drawer back.
 * ========================================================================== */
(function () {
  var MOBILE_MAX = 640;

  function isPhone() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  function apply() {
    if (!window.theme) return;
    var toggle = document.querySelector('.bts-header__cart-toggle');
    if (isPhone()) {
      window.theme.cartType = 'message';
      if (toggle && toggle.getAttribute('data-action') === 'toggle-mini-cart') {
        // Stash the original so we can restore on resize back to desktop.
        toggle.setAttribute('data-bts-orig-action', 'toggle-mini-cart');
        toggle.removeAttribute('data-action');
        toggle.removeAttribute('aria-controls');
        toggle.removeAttribute('aria-expanded');
      }
    } else {
      // Restore drawer behaviour at desktop widths.
      window.theme.cartType = window.theme.bts_originalCartType || window.theme.cartType;
      if (toggle && toggle.getAttribute('data-bts-orig-action') === 'toggle-mini-cart') {
        toggle.setAttribute('data-action', 'toggle-mini-cart');
        toggle.setAttribute('aria-controls', 'mini-cart');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.removeAttribute('data-bts-orig-action');
      }
    }
  }

  function init() {
    if (window.theme && !window.theme.bts_originalCartType) {
      // Remember the merchant-configured cart type once at boot so we can
      // restore it on resize back into desktop range.
      window.theme.bts_originalCartType = window.theme.cartType;
    }
    apply();
    window.addEventListener('resize', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================================
 * Cart count badge -- hide when count is 0.
 *
 * The badge is always rendered (so vendor's `Cart._rerender` can write its
 * `textContent` without throwing on an empty initial cart), and we toggle
 * the `.is-zero` class -- which CSS hides -- whenever the text changes.
 *
 * A MutationObserver covers both the initial paint and every subsequent
 * update from `Cart._rerender` after an add / qty change / remove, so the
 * badge appears the moment the first item is added and disappears when
 * the last one is removed -- no full reload required.
 * ========================================================================== */
(function () {
  function sync(el) {
    var raw = (el.textContent || '').trim();
    var n = parseInt(raw, 10);
    el.classList.toggle('is-zero', !isFinite(n) || n <= 0);
  }

  function wire() {
    var el = document.querySelector('[data-bts-cart-count]');
    if (!el) return;
    sync(el);
    if (typeof MutationObserver === 'function') {
      var obs = new MutationObserver(function () { sync(el); });
      obs.observe(el, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();

/* ============================================================================
 * Compare page (/pages/compare) -- mobile heading copy
 *
 * On desktop the big "Compare Products & Shop Smarter" heading + tagline live
 * in the first cell of the Comparable app's table header row (it is the app's
 * relabelled "show only differences" toggle, styled via .show-different).
 *
 * On mobile we want that heading ABOVE the table. Rather than MOVE the app's
 * own element (it's a toggle the app re-renders and re-wires), we build a
 * static DUPLICATE of the title above the table once: `.bts-compare-heading >
 * .bts-compare-heading__title` (the description is a CSS ::after on the title).
 * Which one is visible -- the in-table heading or this copy -- is decided
 * purely by the CSS media query, so it tracks window resizing on its own with
 * NO JS resize handling. This JS only keeps the copy present and its text in
 * sync with the app's heading (in case the merchant relabels it or the app
 * re-renders the table).
 * ========================================================================== */
(function () {
  /* Gate on the URL, NOT the body class: the `comparison-page` class is added
     by the app's own JS which can run AFTER this deferred script, so checking
     the class here would bail before we ever set up the observer. The pathname
     is available immediately. syncCopy still no-ops on any page that has no
     `.comparison-table`, so this is safe even if the URL check is loose. */
  if (!/compare/i.test(location.pathname) &&
      !(document.body && document.body.classList.contains('comparison-page'))) return;

  var obs = null;

  function syncCopy() {
    var table = document.querySelector('.comparison-table');
    if (!table) return;

    var original = document.querySelector('.product-table__header-row .show-different')
                || document.querySelector('.show-different');
    var titleText = original ? (original.textContent || '').trim() : '';
    if (!titleText) return;

    var block = document.querySelector('.bts-compare-heading');
    if (!block) {
      block = document.createElement('div');
      block.className = 'bts-compare-heading';
      var titleEl = document.createElement('div');
      titleEl.className = 'bts-compare-heading__title';
      block.appendChild(titleEl);
    }
    // Keep the copy directly before the table (survives app re-renders).
    if (table.parentNode && (block.nextSibling !== table || block.parentNode !== table.parentNode)) {
      table.parentNode.insertBefore(block, table);
    }
    var title = block.querySelector('.bts-compare-heading__title');
    if (title && title.textContent.trim() !== titleText) {
      title.textContent = titleText;
    }
  }

  function apply() {
    if (obs) obs.disconnect();
    try {
      syncCopy();
    } finally {
      if (obs) obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  function init() {
    if (typeof MutationObserver === 'function') {
      obs = new MutationObserver(function () { apply(); });
    }
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------------------------------------------------------------------------
   Comparable compare page -- prettify option labels + flag blank cells.
   The Comparable app names comparison options by the raw metafield key
   (lowercase-hyphenated, e.g. "rca-pre-outs"). On the /pages/compare table we
   relabel each option row to its proper name, and tag empty value cells so
   bts.css can render a subtle dash (standard comparison-table treatment).
   Runs only on the compare page; re-applies as the app lazy-loads rows.
   --------------------------------------------------------------------------- */
(function () {
  if (!/compare/i.test(window.location.pathname)) return;

  var SPEC_NAMES = {
    '4g-lte': '4G LTE', 'adas': 'ADAS', 'bankstown-offer': 'Bankstown Offer',
    'battery-type': 'Battery Type', 'beam-angle': 'Beam Angle', 'bluetooth': 'Bluetooth',
    'brand': 'Brand', 'cable-length': 'Cable Length', 'capacity': 'Capacity',
    'certification': 'Certification', 'channels': 'Channels',
    'chassis-mounting-size': 'Chassis Mounting Size', 'color': 'Color', 'colour': 'Colour',
    'compatible-voltage': 'Compatible Voltage', 'cone': 'Cone',
    'continuous-power-handling': 'Continuous Power Handling',
    'country-of-origin': 'Country of Origin', 'dash-camera-link': 'Dash Camera Link',
    'dimensions': 'Dimensions', 'display': 'Display', 'dome': 'Dome',
    'field-of-view': 'Field of View', 'frames-per-second': 'Frames per Second',
    'frequency-response': 'Frequency Response', 'gps': 'GPS', 'hdmi-input': 'HDMI Input',
    'hi-res-audio': 'Hi-Res Audio', 'idatalink-maestro': 'iDatalink Maestro',
    'impedance': 'Impedance', 'ip-rating': 'IP Rating', 'led': 'LED', 'lithium': 'Lithium',
    'light-sensor-and-ir-lights': 'Light Sensor and IR Lights', 'lumen': 'Lumen',
    'magnet': 'Magnet', 'mapping-data': 'Mapping Data', 'material': 'Material',
    'monitoring-app': 'Monitoring App', 'mounting-depth': 'Mounting Depth',
    'mounting-hole-size': 'Mounting Hole Size', 'mounting-method': 'Mounting Method',
    'mounting-type': 'Mounting Type', 'output-power': 'Output Power', 'park-mode': 'Park Mode',
    'peak-power': 'Peak Power', 'power-rms': 'Power (RMS)', 'radio': 'Radio',
    'rca-pre-outs': 'RCA Pre-Outs', 'recharge-time': 'Recharge Time',
    'recommended-for': 'Recommended for', 'recording-modes': 'Recording Modes',
    'remote-capable': 'Remote Capable', 'resolution': 'Resolution',
    'reverse-camera-input': 'Reverse Camera Input', 'run-time-2-channel': 'Run-Time (2 Channel)',
    'screen-resolution': 'Screen Resolution', 'screen-size': 'Screen Size', 'sensor': 'Sensor',
    'size': 'Size', 'smart-phone': 'Smart Phone', 'smart-phone-connectivity': 'Smart Phone Connectivity',
    'speaker': 'Speaker', 'speed': 'Speed', 'speed-class': 'Speed Class', 'storage': 'Storage',
    'this-upgrade-is-for': 'This upgrade is for', 'total-power': 'Total Power',
    'tweeter-magnet': 'Tweeter Magnet', 'usb': 'USB', 'vehicle': 'Vehicle',
    'viewing-angle': 'Viewing Angle', 'warranty': 'Warranty', 'weight': 'Weight',
    "whats-in-the-box": "What's in the Box", 'wifi': 'WiFi', 'woofer-magnet': 'Woofer Magnet'
  };

  // Non-spec fields that got migrated as options but should NOT appear as
  // comparison rows (marketing / narrative, not comparable values).
  var HIDE_KEYS = {
    'bankstown-offer': 1, 'recommended-for': 1, 'this-upgrade-is-for': 1
  };

  function apply() {
    var rows = document.querySelectorAll('table tr');
    if (!rows.length) return;
    rows.forEach(function (tr) {
      var cells = tr.children;
      if (!cells.length) return;
      // First cell = option label. Relabel if it matches a spec key.
      var label = cells[0];
      var key = (label.textContent || '').trim();
      if (HIDE_KEYS[key]) { tr.classList.add('bts-cmp-hide-row'); return; }
      var nice = SPEC_NAMES[key];
      if (nice && label.textContent !== nice) label.textContent = nice;
      // Remaining cells = product values. Tag blanks for the CSS dash.
      for (var i = 1; i < cells.length; i++) {
        var cell = cells[i];
        var blank = (cell.textContent || '').trim() === '' && !cell.querySelector('img, svg, a, button');
        if (blank) cell.classList.add('bts-cmp-blank');
        else cell.classList.remove('bts-cmp-blank');
      }
    });

    // Dedupe: if two rows share the same label (e.g. an old tag-based option
    // plus the migrated metafield one), keep the one with the most filled
    // values and hide the rest.
    var byLabel = {};
    rows.forEach(function (tr) {
      if (tr.classList.contains('bts-cmp-hide-row')) return;
      var cells = tr.children;
      if (!cells.length) return;
      var lbl = (cells[0].textContent || '').trim();
      if (!lbl) return;
      var filled = 0;
      for (var i = 1; i < cells.length; i++) {
        if ((cells[i].textContent || '').trim() !== '') filled++;
      }
      (byLabel[lbl] = byLabel[lbl] || []).push({ tr: tr, filled: filled });
    });
    Object.keys(byLabel).forEach(function (lbl) {
      var group = byLabel[lbl];
      if (group.length < 2) return;
      group.sort(function (a, b) { return b.filled - a.filled; });
      group.slice(1).forEach(function (g) { g.tr.classList.add('bts-cmp-hide-row'); });
    });
  }

  var pending;
  function schedule() { clearTimeout(pending); pending = setTimeout(apply, 80); }

  apply();
  if (typeof MutationObserver === 'function') {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
})();


/* ==========================================================================
   bts-countdown -- per-product sale countdown bar (PDP)

   Markup comes from snippets/bts-countdown.liquid, which renders the bar
   [hidden] with the absolute end time (unix seconds) in data-ends-at.
   This element is the single authority on visibility: it reveals the bar
   only while time remains and removes it the moment it expires, so pages
   served stale from the CDN cache can never show a dead or frozen timer.
   Variant changes replace the whole variant-selector block (see
   product-rerender in theme.js); connectedCallback re-runs automatically
   on the fresh markup and disconnectedCallback stops the old interval.
   ========================================================================== */
(function () {
  'use strict';

  if (window.customElements.get('bts-countdown')) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  class BtsCountdown extends HTMLElement {
    connectedCallback() {
      this._endsAt = parseInt(this.getAttribute('data-ends-at'), 10) * 1000;
      if (!this._endsAt) {
        this.remove();
        return;
      }
      this._tick = this._tick.bind(this);
      this._tick();
      this._interval = setInterval(this._tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    _set(unit, value) {
      var el = this.querySelector('[data-bts-cd="' + unit + '"]');
      if (el) el.textContent = pad(value);
    }

    _tick() {
      var left = Math.floor((this._endsAt - Date.now()) / 1000);
      if (left <= 0) {
        clearInterval(this._interval);
        this.remove();
        return;
      }
      var days = Math.floor(left / 86400);
      this._set('days', days);
      this._set('hours', Math.floor((left % 86400) / 3600));
      this._set('minutes', Math.floor((left % 3600) / 60));
      this._set('seconds', left % 60);
      var daysUnit = this.querySelector('[data-bts-cd-unit="days"]');
      if (daysUnit) daysUnit.hidden = days <= 0;
      this.removeAttribute('hidden');
    }
  }

  window.customElements.define('bts-countdown', BtsCountdown);
})();
